const AboutPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-12">
        <h1 className="text-4xl font-outfit font-bold tracking-tight text-slate-900 mb-8">
          About dxb2bom
        </h1>
        <div className="space-y-4 text-slate-600">
          <p>Your trusted platform for premium products from Dubai to Mumbai.</p>
          <p>We handle purchase and delivery, bringing luxury and quality products right to your doorstep.</p>
        </div>
      </div>
    </div>
  );
};

export default AboutPage;